import React, { useState, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, CarIcon, PenToolIcon, ShieldIcon, ZapIcon } from 'lucide-react';
export const PortfolioSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const projects = [{
    title: 'BMW 3-Series Premium Finish',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/epTaMYxL4anUJLdbRfE6sf/Afbeelding-van-WhatsApp-op-2024-09-11-om-03.56.27_c7bf755e.jpg',
    description: 'Elegante rode BMW met zwarte accenten en premium afwerking in onze professionele studio.',
    features: ['Sportieve uitstraling', 'Zwarte accenten', 'Glanzende afwerking'],
    type: 'Premium Car Styling'
  }, {
    title: 'Mercedes-Benz Vito Black Edition',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2BmxpFXUm1C8xaNUxk17xV/Afbeelding-van-WhatsApp-op-2024-09-12-om-10.45.40_b41d2ffd.jpg',
    description: 'Mercedes bedrijfsvoertuig met custom zwarte grille en bumper voor een stoere, professionele uitstraling.',
    features: ['Chrome delete', 'Zwarte accenten', 'Professionele uitstraling'],
    type: 'Bedrijfswagen Styling'
  }, {
    title: 'Volkswagen Golf R Signature Blue',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bV7uXCz26reNCSdJt3r47x/Afbeelding-van-WhatsApp-op-2024-09-12-om-10.45.41_5602992b.jpg',
    description: 'Sportieve VW Golf in opvallend blauw met zwarte grille en bumper voor een krachtige look.',
    features: ['Sportieve styling', 'Zwarte details', 'Verlaagd profiel'],
    type: 'Sport Edition'
  }, {
    title: 'Mercedes-AMG Custom White',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3v8Pos7TXNGtqMbGvoXuvd/Afbeelding-van-WhatsApp-op-2024-09-12-om-10.45.41_fb59bef4.jpg',
    description: 'Exclusieve Mercedes-AMG in stralend wit met zwarte Panamericana grille en sportieve details.',
    features: ['Premium afwerking', 'Sportieve uitstraling', 'AMG styling'],
    type: 'Luxury Performance'
  }];
  const nextSlide = () => {
    setActiveIndex(prevIndex => (prevIndex + 1) % projects.length);
  };
  const prevSlide = () => {
    setActiveIndex(prevIndex => (prevIndex - 1 + projects.length) % projects.length);
  };
  const getFeatureIcon = (index: number) => {
    switch (index % 4) {
      case 0:
        return <CarIcon size={16} className="text-[#D6281F]" data-id="element-395" data-mp="33rl49pm1f281" />;
      case 1:
        return <PenToolIcon size={16} className="text-[#D6281F]" data-id="element-396" data-mp="33to22vtflznb" />;
      case 2:
        return <ShieldIcon size={16} className="text-[#D6281F]" data-id="element-397" data-mp="37u8001ltx7ai" />;
      case 3:
        return <ZapIcon size={16} className="text-[#D6281F]" data-id="element-398" data-mp="3crzo0kjcs99f" />;
    }
  };
  return <section id="portfolio" className="py-16 bg-[#0a0a0a]" data-id="element-399" data-mp="1dg715gqa4kaf">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-400" data-mp="1dhrvb58om17r">
        <div className="text-center mb-10" data-id="element-401" data-mp="1if0e981nm9a2">
          <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-402" data-mp="1auz8i1rq88to">
            <span className="text-[#D6281F]" data-id="element-403" data-mp="1awaapx5ix8io">Recente</span>{' '}
            <span className="text-white" data-id="element-404" data-mp="163z98pv4xeo0">Projecten</span>
          </h2>
          <p className="text-[#CCCCCC] max-w-2xl mx-auto text-sm md:text-base" data-id="element-405" data-mp="1155zn8iyy7t4">
            Ontdek onze meest recente transformaties uit onze premium studio.
          </p>
        </div>
        <div className="relative" data-id="element-406" data-mp="w48hgvxyldrm">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-407" data-mp="1tu3ef1nz1mh4">
            {/* Left side: Current active image with aspect ratio container */}
            <div className="relative rounded-md overflow-hidden shadow-lg border border-white/10 group" data-id="element-408" data-mp="1osns76a259x5">
              <div className="relative" data-id="element-409" data-mp="1jxi8me44o7c8">
                {/* Aspect ratio container */}
                <div className="relative w-full bg-[#121212]" style={{
                paddingBottom: '75%'
              }} data-id="element-410" data-mp="1fw53654y665u">
                  <img src={projects[activeIndex].imageUrl} alt={projects[activeIndex].title} className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" decoding="async" data-id="element-411" data-mp="4dlttgp4dc8z" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 group-hover:opacity-50 transition-opacity duration-300" data-id="element-412" data-mp="1nbqk9un168bf"></div>
                <div className="absolute top-3 right-3" data-id="element-413" data-mp="2b09u4elqat5m">
                  <div className="bg-black/70 backdrop-blur-sm px-2 py-1 rounded border border-white/10" data-id="element-414" data-mp="2fzutur8q35je">
                    <span className="text-white/90 text-xs font-medium" data-id="element-415" data-mp="220v1b8i3a6hy">
                      BKCustoms Studio
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Right side: Project details */}
            <div className="flex flex-col justify-center" data-id="element-416" data-mp="uo32soh23xt0">
              <div className="bg-[#121212] p-6 rounded-md border border-white/10 h-full" data-id="element-417" data-mp="ulhzdv1419t5">
                <div className="inline-flex items-center bg-[#D6281F]/10 px-2 py-1 rounded mb-4" data-id="element-418" data-mp="n6emshj4pc08">
                  <span className="text-[#D6281F] text-xs font-medium" data-id="element-419" data-mp="i7bgyuvbr1r7">
                    {projects[activeIndex].type}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-420" data-mp="s4pyyywwbylm">
                  {projects[activeIndex].title}
                </h3>
                <p className="text-[#CCCCCC] text-base mb-6" data-id="element-421" data-mp="4bhjr93wy0tx">
                  {projects[activeIndex].description}
                </p>
                <div className="space-y-2 mb-6" data-id="element-422" data-mp="e45bvqjy7gmb">
                  {projects[activeIndex].features.map((feature, idx) => <div key={idx} className="flex items-center" data-id="element-423" data-mp="9c59lrgeobmk" data-mpi={idx}>
                      {getFeatureIcon(idx)}
                      <span className="ml-2 text-white/80 text-sm" data-id="element-424" data-mp="3hr5rjslxm3wk">
                        {feature}
                      </span>
                    </div>)}
                </div>
                <div className="flex items-center justify-between" data-id="element-425" data-mp="6bvm70sot05d">
                  <div className="flex space-x-1.5" data-id="element-426" data-mp="ad72ugtl2b1f">
                    {projects.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`w-2 h-2 rounded-full transition-all duration-200 ${index === activeIndex ? 'bg-[#D6281F]' : 'bg-[#333333] hover:bg-[#D6281F]/50'}`} aria-label={`Go to project ${index + 1}`} data-id="element-427" data-mp="f5qgfds9t668" data-mpi={index} />)}
                  </div>
                  <div className="flex space-x-2" data-id="element-428" data-mp="3siaekke21lat">
                    <button onClick={prevSlide} className="bg-[#121212] border border-[#333333] hover:border-[#D6281F] text-white p-1.5 rounded transition-colors duration-200" aria-label="Previous project" data-id="element-429" data-mp="1dtujrh73sia">
                      <ChevronLeftIcon size={18} data-id="element-430" data-mp="2xb1efr88lw76" />
                    </button>
                    <button onClick={nextSlide} className="bg-[#D6281F] text-white p-1.5 rounded transition-colors duration-200" aria-label="Next project" data-id="element-431" data-mp="2sbf0ffkl4bxb">
                      <ChevronRightIcon size={18} data-id="element-432" data-mp="2ikkao184qu74" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Thumbnail preview with aspect ratio containers */}
          <div className="hidden md:grid grid-cols-4 gap-3" data-id="element-433" data-mp="29n088oyj6rux">
            {projects.map((project, index) => <div key={index} onClick={() => setActiveIndex(index)} className={`cursor-pointer rounded overflow-hidden border ${index === activeIndex ? 'border-[#D6281F]' : 'border-white/10 hover:border-white/30'} transition-colors duration-200`} data-id="element-434" data-mp="1zmrav7ssz0dy" data-mpi={index}>
                <div className="relative w-full" style={{
              paddingBottom: '75%'
            }} data-id="element-435" data-mp="32volrva6yfz1">
                  <img src={project.imageUrl} alt={project.title} className="absolute inset-0 w-full h-full object-cover object-center" decoding="async" data-id="element-436" data-mp="37wc9o834igp1" />
                  <div className={`absolute inset-0 bg-black/50 ${index === activeIndex ? 'opacity-0' : 'opacity-70'} hover:opacity-30 transition-opacity duration-200`} data-id="element-437" data-mp="2k3vo3nk6g6kz"></div>
                </div>
              </div>)}
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-438" data-mp="2f6vi1cnbv3tv">
          <a href="#contact" className="inline-flex items-center text-white bg-[#121212] border border-[#333333] hover:border-[#D6281F] px-5 py-2 rounded transition-colors duration-200 text-sm" data-id="element-439" data-mp="2f7wy5vj7agig">
            Vraag ons advies voor jouw auto
          </a>
        </div>
      </div>
    </section>;
};